<template>
  <component v-model="value" :is="newComponentName" v-on="$listeners" v-bind="{ ...$props }"/>
</template>

<script>
import MasterReadRelationship from './components/master-read-relationship.vue'
import MasterEditRelationship from './components/master-edit-relationship.vue'
import { masterDetailRelationshipProps } from './index'
export default {
  name: 'master-relationship',
  props: masterDetailRelationshipProps,
  model: {
    prop: 'value',
    event: 'change'
  },
  components: {
    MasterReadRelationship,
    MasterEditRelationship
  },
  computed: {
    newComponentName () {
      if (this.isPureText) {
        return 'master-read-relationship'
      }
      return 'master-edit-relationship'
    }
  }
}
</script>

<style scoped lang='scss'>
  .read-relationship {
    color: rgb(48, 114, 243);
    cursor: pointer;
  }
</style>
